const skeleton_statsLabel = Object.freeze({
    '미신청': 'not_requested',
    '신청함': 'requested',
    '답변중': 'in_progress',
    '보완중': 're_progress',
    '평가중': 'in_assessment',
    '완료됨': 'completed',
    '취소됨': 'canceled',
    '에코바디스': 'eco_vadis'
})

const skeleton_statsLabel_eng = Object.freeze({
    'not_requested': '미신청',
    'requested': '신청함',
    'in_progress': '답변중',
    're_progress': '보완중',
    'in_assessment': '평가중',
    'completed': '완료됨',
    'canceled': '취소됨',
    'eco_vadis': '에코바디스'
})

const skeleton_stats = {
    total: 0,
    fields: {
        '미신청': 0,
        '신청함': 0,
        '답변중': 0,
        '보완중': 0,
        '평가중': 0,
        '완료됨': 0,
        '취소됨': 0,
        '에코바디스': 0
    },
    colors: {
        '미신청': '#FFA500',
        '신청함': '#8BC34A',
        '답변중': '#43A047',
        '보완중': '#009688',
        '평가중': '#039BE5',
        '완료됨': '#1976D2',
        '취소됨': '#F4511E',
        '에코바디스': '#ffc107'
    }
}

// 밝은 상태색(미신청·신청함·에코바디스) 위에는 흰 글자 대비가 부족해 어두운 글자를 쓴다. 나머지는 흰 글자
const skeleton_stats_text_colors = Object.freeze({
    '미신청': '#212529',
    '신청함': '#212529',
    '에코바디스': '#212529'
})

const skeleton_participants = []

const skeleton_dates = {
    start_date: '',
    end_date: '',
    target_end_date: '',
    start_date_dis: '미지정',
    end_date_dis: '미지정',
    target_end_date_dis: '미지정',
}

export default {
    name: 'data-skeleton-risk-monitoring',
    data () {
        return {
            stats: { ...skeleton_stats },
            statsLabel: skeleton_statsLabel,
            statsLabel_eng: skeleton_statsLabel_eng,
            statsTextColors: skeleton_stats_text_colors,
            participants: skeleton_participants,
            projectDates: skeleton_dates
        }
    },
    computed: {},
    created () {},
    mounted () {},
    methods: {
        // initializeRiskMonitoring () {
        //     this.initializeSummaryData()
        // },
        // initializeSummaryData () {
        //     this.resultSummary = Object.assign({}, skeleton_summary)
        // }
    }
}